



















import { Component, Vue, Prop } from 'vue-property-decorator'
import { GameResult } from '@/class/game'
import Player from './Player.vue'

@Component({
  components: {
    Player
  }
})
export default class ReplayResultViewer extends Vue {
  @Prop() gameResult!: GameResult;

  get winners() {
    return Object.values(this.gameResult.players).filter(p => p.isWinner)
  }

  get losers() {
    return Object.values(this.gameResult.players).filter(p => !p.isWinner)    
  }
}
